import { Theme, useMediaQuery } from '@mui/material';
import { useSelector } from 'react-redux';

import { EVENT_CONSTANTS } from '@/services';
import {
  selectUserAudienceRegions,
  selectUserCompliance,
  useFetchFeaturedEpisodesQuery,
} from '@/store';

import { EpisodeCardVariants } from '../EpisodeCard';
import { EpisodeCardCarousel } from '../EpisodeCardCarousel';

export const FeaturedEpisodesCarousel = () => {
  const isMobile = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down('md'),
  );

  const audienceRegions = useSelector(selectUserAudienceRegions);
  const compliance = useSelector(selectUserCompliance);

  const { data: featuredEpisodes, isLoading } = useFetchFeaturedEpisodesQuery({
    compliance,
    audienceRegions,
    applyRelevanceBoost: true,
  });

  return (
    <>
      {(isLoading || (featuredEpisodes && featuredEpisodes?.length > 0)) && (
        <EpisodeCardCarousel
          uKey="Featured Episodes"
          episodes={featuredEpisodes}
          isLoading={isLoading}
          variant={
            isMobile ? EpisodeCardVariants.LARGE : EpisodeCardVariants.JUMBO
          }
          referrer={{
            page: EVENT_CONSTANTS.PAGE.DISCOVER,
          }}
        />
      )}
    </>
  );
};
